/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatCsvIcon16Light } from './FileFormatCsvIcon16Light';
import { FileFormatCsvIcon16Regular } from './FileFormatCsvIcon16Regular';
import { FileFormatCsvIcon16Solid } from './FileFormatCsvIcon16Solid';
import { FileFormatCsvIcon20Light } from './FileFormatCsvIcon20Light';
import { FileFormatCsvIcon20Regular } from './FileFormatCsvIcon20Regular';
import { FileFormatCsvIcon20Solid } from './FileFormatCsvIcon20Solid';
import { FileFormatCsvIcon24Regular } from './FileFormatCsvIcon24Regular';
import { FileFormatCsvIcon24Solid } from './FileFormatCsvIcon24Solid';
import { FileFormatCsvIcon32Regular } from './FileFormatCsvIcon32Regular';
import { FileFormatCsvIcon64Regular } from './FileFormatCsvIcon64Regular';
var sizes = {
    16: {
        light: FileFormatCsvIcon16Light,
        regular: FileFormatCsvIcon16Regular,
        solid: FileFormatCsvIcon16Solid,
    },
    20: {
        light: FileFormatCsvIcon20Light,
        regular: FileFormatCsvIcon20Regular,
        solid: FileFormatCsvIcon20Solid,
    },
    24: {
        regular: FileFormatCsvIcon24Regular,
        solid: FileFormatCsvIcon24Solid,
    },
    32: {
        regular: FileFormatCsvIcon32Regular,
    },
    64: {
        regular: FileFormatCsvIcon64Regular,
    },
};
export var FileFormatCsvIcon = forwardRef('FileFormatCsvIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
